import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { userInfo } from 'os';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDocument',
  template: `
  <!-- this condition was on button below *ngIf="params?.data.status == 'Active' && params?.isShowEdit-->
    <button [disabled]="params.data.isEditAllowed != 1"
      mat-mini-fab
      color="primary"
      title="Edit"
      (click)="onClick($event)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      title="Draft Options"
      (click)="onClick($event)"
      [hidden]="hideApprovalLvl"
    >
    <mat-icon>assignment</mat-icon></button>

    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      title="Approve/Reject"
      (click)="onClick($event)"
      [disabled]="params.data.disableDraft || this.approveReject"
    >
    <mat-icon>check</mat-icon>
    </button>

    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == false ? true : false"
    mat-mini-fab
    color="accent"
    title="Draft Options"
    (click)="onClick($event)"
    [disabled]="params.data.disableApproved"
  >
  <mat-icon>alarm icon</mat-icon></button>

    <button *ngIf="params?.data.status == 'Inactive' || params?.data.status == 'Rejected'"
      mat-mini-fab
      color="warn"
      title="Draft Options"
      (click)="onClick($event)"
    >
    <mat-icon>warning</mat-icon>
    </button>
    <button [hidden]="true"
      mat-mini-fab
      color="accent"
      title="View Document"
      (click)="onClick($event)"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <!--<button
      mat-mini-fab
      color="warn"
      title="Download Document"
      (click)="onClick($event)">
      <mat-icon>download</mat-icon>
    </button>-->

    <button
    mat-mini-fab
    color="primary"
    title="Open Chat"
    (click)="onClick($event)"
    [disabled]="params.data.disableChat">
    <mat-icon>chat</mat-icon>
  </button>

   <button *ngIf="params.data.status == 'Active'"
    mat-mini-fab
    color="accent"
    title="Open CR"
    (click)="onClick($event)">
    <div *ngIf="params.data.pendingCRCount > 0" class='crCount' style="position: absolute; top: -2px; right: -5px; background-color: #dc2626; color: white; font-weight: 500; padding: 0.3rem; padding-left: 0.5rem; padding-right: 0.5rem;z-index: 100; font-size: 0.5rem; border-radius: 50%">{{params.data.pendingCRCount}}</div>
    <mat-icon><mat-icon>settings_backup_restore</mat-icon></mat-icon>
  </button>
      <button *ngIf="params.data.status == 'Active' && params.data.isEditAllowed == 1"
      mat-mini-fab
      color="warn"
      style="background-color: #f1b718ff;"
      title="Set Assignees"
      (click)="onClick($event)"
    >
      <mat-icon>assignment_turned_in</mat-icon>
    </button>

  <mat-slide-toggle [ngStyle]="getToggleStyle(params)" *ngIf="params.data.isEditAllowed != 0 && (params.data.status =='Active' ? params.isDeActivate : params.isActive)" title="Active/Inactive" [disabled]="params.data.disableActToggle" [checked]="params.data.status =='Active' ?  true : false"></mat-slide-toggle>


  
   
    <!-- <button
      mat-mini-fab
      color="warn"
      style="background-color: #000;"
      title="Document Questions"
      (click)="onClick($event)"
    >
      <mat-icon>question_answer</mat-icon>
    </button> -->
  
  `,
  styles: [
    `
      button {
        height: 35px;
        width: 35px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 3px;
      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererDocument implements ICellRendererAngularComp {
  public params: any;
  public approveReject:boolean = true;
  public hideApprovalLvl:boolean = false;
  refresh(params: any): boolean {
    //throw new Error('Method not implemented.');
    this.params = params;
    return true;
  }
  public agInit(params: any): void {
    let userdata = JSON.parse(localStorage.logged_in_user);
    let userCode = userdata.userCode;
    this.params = params;
    if(this.params.data.totalLevelApproversEmpId.includes(userCode))
    {
      this.approveReject = false;
    }
    if(params.data.approvalAuthorityPosition === 'owner')
    {
      if(params.data.draftOwner === userCode)
      {
        this.approveReject = false;
      }
      if(params.data.isSuperAdmin === true)
      {
        this.approveReject = false;
      }
      this.hideApprovalLvl  = true;
    }
  }
  onClick($event: any): any {

    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }

  getToggleStyle(params: any) {
    return params.data.status === 'Draft' ? { display: 'none' } : {};
  }
}
